import './popup.less';
import {openHtmlDialog} from "./dialog";

/**
 * The same as {@link openHtmlDialog()} but with name='popup' enabled
 * @param {*} content HTML content
 * @param {object} options ZDialog options
 * @return {ZDialog} Dialog instance
 */
export function openPopup(content, options = null) {
	return openHtmlDialog(content, {name: 'popup', ...options});
}



// WEBPACK FOOTER //
// ./core/widgets/popup.js